import { allowTabCharacter } from 'common/components/textarea/Textarea'

const MAX_HTML_LENGTH = 100000

type Props = {
  html: string
  onHtmlChange: (html: string) => void
}

const PasteHtmlTabContent = ({ html, onHtmlChange }: Props) => (
  <div className="flex gap-6 flex-1 min-h-0">
    <div className="flex-1 flex flex-col min-w-0">
      <textarea
        value={html}
        onChange={(e) => onHtmlChange(e.target.value)}
        onKeyDown={allowTabCharacter}
        placeholder="Paste your HTML..."
        maxLength={MAX_HTML_LENGTH}
        data-testid="paste-html-modal-textarea"
        className="flex-1 min-h-0 w-full resize-none font-mono text-sm bg-white text-gold-700 placeholder:text-gold-500 border-1 border-gold-400 hover:border-gold-500 focus:border-base-700 rounded-sm px-4 py-3 outline-none"
      />
      <p className="text-xs text-base-500 pt-2 shrink-0">
        Personalisation tags like {'{{first_name}}'} are filled with sample
        values in the preview.
      </p>
    </div>
    <div className="flex-1 flex flex-col min-w-0 border-l border-gold-400 pl-6">
      {html.trim() ? (
        <iframe
          srcDoc={html}
          className="w-full flex-1 min-h-0 border border-gold-400 rounded-sm"
          sandbox=""
          title="Pasted HTML preview"
        />
      ) : (
        <div className="flex-1 flex items-center justify-center text-lg text-base-700 text-center bg-gold-300/25 rounded-sm">
          Paste HTML to see a preview.
        </div>
      )}
    </div>
  </div>
)

export default PasteHtmlTabContent
